// extracted by mini-css-extract-plugin
export default {"container":"ServiceLightItem_container__l0Ngo","text":"ServiceLightItem_text__YdWck","iconContainer":"ServiceLightItem_iconContainer__K6Kel"};